<template funtional>
  <span v-if="existsFor > 7">
    <feather-icon :icon="icon" svgClasses="h-3 w-3" />
      {{existsText}} for {{existsFor}} days
  </span>
</template>

<script>
import { daysFromDate } from '@/helpers/date'

export default {
  props: ['createdAt', 'done'],

  computed: {
    existsFor () {
      // return Math.round(Math.random() * 10)
      if (!this.createdAt) return 0
      return daysFromDate(this.createdAt)
    },
    icon () {
      return this.done ? 'CheckIcon' : 'AlertTriangleIcon'
    },
    existsText () {
      return this.done ? 'existed' : 'exists'
    }
  }

}
</script>
